import lrz from "lrz";

export async function compress(target) {
  if (target.size < 1024 * 1024 * 2) {
    return { file: target };
  }
  const result = await lrz(target, {
    width: 2500,
    height: 2500,
    quality: 0.9
  });
  const { file } = result;
  return { file: blobToFile(file, target.name, target.lastModifiedDate) };
}

function blobToFile(theBlob, fileName, lastModifiedDate) {
  if (theBlob instanceof File) return theBlob;
  // A Blob() is almost a File() - it's just missing the two properties below which we will add
  theBlob.lastModifiedDate = lastModifiedDate;
  theBlob.name = fileName;
  return new File([theBlob], fileName);
}
